import isNumber from "./isNumber";

export const MIN_QUANTITY = 1;
export const MAX_QUANTITY = 9999;
export const INVALID_QUANTITY_ERROR_MESSAGE = `The quantity must be a whole number between ${MIN_QUANTITY} and ${MAX_QUANTITY}`;

const isValidQuantity = quantity => {
  if (!isNumber(quantity)) return false;

  const numericQuantity = Number(quantity);

  return (
    Number.isInteger(numericQuantity) &&
    numericQuantity >= MIN_QUANTITY &&
    numericQuantity <= MAX_QUANTITY
  );
};

export default isValidQuantity;
